import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TokenInputDialogData {
  title: string;
  message: string;
  defaultToken?: string;
}

@Component({
    selector: 'app-token-input-dialog',
    template: `
    <div class="tw-p-4 tw-bg-white dark:tw-bg-gray-800">
      <h2 class="tw-text-lg tw-font-semibold tw-mb-4 tw-text-gray-900 dark:tw-text-gray-100">{{ data.title }}</h2>
      <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-300 tw-mb-4">{{ data.message }}</p>

      <app-alert
        alertType="warning"
        [hasBorder]="true"
        [closeable]="false"
        class="tw-mb-4">
        <strong>DO NOT USE</strong> this unless you know what you're doing
      </app-alert>

      <mat-form-field appearance="outline" class="tw-w-full tw-mb-4">
        <mat-label>Access Link Token</mat-label>
        <input
          matInput
          [(ngModel)]="token"
          placeholder="6 character alphanumeric token (e.g. ABC123)"
          (keyup.enter)="onConfirm()"
          maxlength="6"
          class="tw-text-gray-900 dark:tw-text-gray-100 tw-uppercase">
        <mat-error *ngIf="hasValidationError">
          Token must be exactly 6 alphanumeric characters
        </mat-error>
      </mat-form-field>

      <div class="tw-flex tw-justify-end tw-gap-2">
        <button mat-button (click)="onCancel()" class="tw-text-gray-700 dark:tw-text-gray-300">Cancel</button>
        <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="!isValidToken(token)">
          Update Cache
        </button>
      </div>
    </div>
  `,
    styles: [],
    standalone: false
})
export class TokenInputDialogComponent {
  token: string = '';

  constructor(
    public dialogRef: MatDialogRef<TokenInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TokenInputDialogData
  ) {
    this.token = data.defaultToken || '';
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    if (this.isValidToken(this.token)) {
      this.dialogRef.close(this.token.trim().toUpperCase());
    }
  }

  isValidToken(token: string): boolean {
    if (!token) return false;
    const trimmed = token.trim();
    const tokenRegex = /^[A-Z0-9]{6}$/;
    return tokenRegex.test(trimmed.toUpperCase());
  }

  get hasValidationError(): boolean {
    return this.token?.trim().length > 0 && !this.isValidToken(this.token);
  }
}
